import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'offer-info-modal',
    templateUrl: './offer-info-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OfferInfoModalComponent {
  @Input() obj: any;
}
